import CommunityTopSection from './CommunityTopSection';
import CommunityBottomSection from './CommunityBottomSection';

const Community = () => {
  return (
    <>
      <CommunityTopSection />
      <CommunityBottomSection />
    </>
  );
};

export default Community;
